import React from 'react';

interface Props {
    children: React.ReactNode;
    className: string;
}
export default class PaneMenu extends React.PureComponent<Props, {}> {
    static defaultProps = {
        className: '',
    };

    render() {
        const { className, children } = this.props;

        let classNames: Array<string> = [className, 'ct-pane-menu'];

        return <ul className={classNames.join(' ')}>{children}</ul>;
    }
}
